"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var storybook_1 = require("@eyecons/storybook");
var react_1 = __importDefault(require("react"));
var ra_fetch_1 = require("ra-fetch");
var prop_types_1 = __importDefault(require("prop-types"));
var Title = function (_a) {
    var title = _a.title;
    return react_1.default.createElement("div", { className: 'flex justify-between' },
        react_1.default.createElement(storybook_1.Texts.Heading, { type: 'h2' }, title));
};
function Delete(_a) {
    var video = _a.video;
    var _b = ra_fetch_1.useApi('backend').delete('videos', {
        id: video.id,
        channel_id: video.channel.id,
    }), destroy = _b[0], submitDestroy = _b[1];
    return react_1.default.createElement(storybook_1.Buttons.Button, { type: 'primary', icon: 'trash', disabled: destroy.submitting, onClick: function () { return submitDestroy().then(function () {
            window.location.reload();
        }); } }, "Verwijderen");
}
function Ads(_a) {
    var ad = _a.ad, video = _a.video, setUpload = _a.setUpload, channel = _a.channel;
    return react_1.default.createElement("div", { className: 'storybook-channels-brand' },
        react_1.default.createElement("div", { className: 'col-span-5' },
            react_1.default.createElement(storybook_1.Videos.FormPlayer, { channel: channel, id: video.id, video: video, setUpload: setUpload })),
        react_1.default.createElement("div", { className: 'col-span-7' },
            react_1.default.createElement(Title, { title: ad.name }),
            react_1.default.createElement(storybook_1.Forms.Field, null,
                react_1.default.createElement(storybook_1.Texts.Primary, null, ad.description)),
            video.length &&
                video.length.seconds > 20 &&
                react_1.default.createElement(storybook_1.Forms.Error, null, "Deze video is langer dan 20 seconden, en wordt daarom niet afgespeeld."),
            video.id && react_1.default.createElement(Delete, { video: video })));
}
exports.default = Ads;
Ads.propTypes = {
    ad: prop_types_1.default.object,
    video: prop_types_1.default.object,
    setUpload: prop_types_1.default.func,
};
